import { createReducer, on } from "@ngrx/store";

import * as OwnerFeatureFlagActions from "./owner-feature-flags.actions";
import { ProductFeatureSummary } from "./owner-feature-flags.models";

export interface OwnerFeatureFlagsState {
  summaries: ProductFeatureSummary[] | null;
  loadError: string | null;
  bulkSaving: boolean;
  bulkSaveError: string | null;
}

export const initialState: OwnerFeatureFlagsState = {
  summaries: null,
  loadError: null,
  bulkSaving: false,
  bulkSaveError: null,
};

export const ownerFeatureFlagsReducer = createReducer(
  initialState,

  on(OwnerFeatureFlagActions.loadAllProductsFeatures, state => ({
    ...state,
    summaries: null,
    loadError: null,
  })),

  on(
    OwnerFeatureFlagActions.loadAllProductsFeaturesSuccess,
    (state, { summaries }) => ({ ...state, summaries })
  ),

  on(
    OwnerFeatureFlagActions.loadAllProductsFeaturesFailure,
    (state, { error }) => ({ ...state, loadError: error })
  ),

  on(OwnerFeatureFlagActions.bulkSetProductFeatures, state => ({
    ...state,
    bulkSaving: true,
    bulkSaveError: null,
  })),

  on(
    OwnerFeatureFlagActions.bulkSetProductFeaturesSuccess,
    (state, { update }) => {
      // Index changes by productId → featureId → enable for O(1) lookup
      const changeIndex = new Map<string, Map<string, boolean>>();
      for (const change of update.changes) {
        if (!changeIndex.has(change.productId))
          changeIndex.set(change.productId, new Map());
        changeIndex.get(change.productId)!.set(change.featureId, change.enable);
      }
      return {
        ...state,
        bulkSaving: false,
        summaries:
          state.summaries?.map(summary => {
            const featureChanges = changeIndex.get(summary.productId);
            if (!featureChanges) return summary;
            return {
              ...summary,
              features: summary.features.map(f => ({
                ...f,
                isEnabled: featureChanges.has(f.id)
                  ? featureChanges.get(f.id)!
                  : f.isEnabled,
              })),
            };
          }) ?? null,
      };
    }
  ),

  on(
    OwnerFeatureFlagActions.bulkSetProductFeaturesFailure,
    (state, { error }) => ({
      ...state,
      bulkSaving: false,
      bulkSaveError: error,
    })
  )
);
